import { ENTER_KEY } from '../constants/commonConstants';

export const ifEnterKey = <T>(e: React.KeyboardEvent<T>, callback: (e: React.KeyboardEvent<T>) => void | undefined) => {
  const { key } = e;
  if (key !== ENTER_KEY) return;
  callback?.(e);
};
